<div
  *ngrxLet="customFacade.customStorageError$ as error"
  class="modal-content"
  piqetAngularDraggable
>
  <ng-container *ngrxLet="customFacade.storageProcessList$ as storageProcessList">
    <div class="modal-header">
      <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
        <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
      </h2>

      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body body-modal" style="margin-top: 10px">
      <form
        id="frmProjectCreate"
        [formGroup]="customStorageForm"
        [ngClass]="{ 'disabled-popup': !checkEntireAccess }"
      >
        <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <h4 class="storageTitle">Storage for 1 m<sup>3</sup>per day</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="storageName"
                [control]="customStorageForm.get('storageName')"
                label="Storage process name"
                placeholder="Storage process name"
                [maxLength]="50"
                [submitted]="submitted"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" *ngIf="isHideDropDown">
            <div class="form-group required">
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #material
                [items]="organizationlist"
                [searchable]="false"
                bindLabel="name"
                formControlName="organizationName"
                [searchFn]="commonInputSearch"
                [readonly]="isDisabledDropDown"
                placeholder="Organization"
                [(ngModel)]="setOrganizationValue"
                (change)="selectValue($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      (input)="material.filter($any($event.target).value)"
                      class="accordion-search form-control search-input"
                      id="inputValidation"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (customStorageForm.controls['organizationName']?.touched &&
                    customStorageForm.controls['organizationName']?.invalid) ||
                  customStorageForm.controls['organizationName'].value?.name === 'Organization' ||
                  (submitted && !customStorageForm.controls['organizationName'].value?.name)
                "
                class="input-error"
              >
                Organization is required.
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="portlet light">
        <div class="portlet-title">
          <div class="caption">
            <span class="font-sharp">Process for storage</span>
          </div>
        </div>
      </div>
      <div id="divmanufactureofmaterialList" class="grid-div cutomBtn-margin">
        <input
          data-val="true"
          data-val-number="The field CustomMaterialId must be a number."
          data-val-required="The CustomMaterialId field is required."
          type="hidden"
          value="0"
        />
        <piqet-angular-portlet
          [columnDefs]="processColumnDef"
          [frameworkComponents]="frameworkComponents"
          [gridData]="storageProcessList"
          [hidePagination]="true"
          [hideSearch]="true"
          [headerBtn]="headerBtn"
          [headerBtnName]="headerBtnName"
          [disableButton]="disableSubmit || isRowEditable"
          [createAccess]="checkEntireAccess"
          [showErrorInAccordian]="true"
          [isCheckOrgaizationReport]="true"
          [error]="error || errorNotification"
          (editDataEvent)="checkValidation(error)"
          (inlineDataEditEvent)="inlineDataEditEvent($event)"
          [isInlineGrid]="true"
          [class]="'overflowCheck'"
        >
        </piqet-angular-portlet>
      </div>
    </div>
    <div class="modal-footer">
      <ng-container *ngrxLet="customFacade.storageProcessList$ as storageProcessList">
        <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
        <button
          type="button"
          class="modelBtn purpleBtnHoverEffect"
          *ngIf="checkEntireAccess"
          [disabled]="disableSubmit || isRowEditable"
          (click)="onSave(storageProcessList)"
        >
          Save
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>
